const defaultState = {
    loading: {}
}

export default (state=defaultState, action) => {
    switch(action.type) {
        case "LOADING": return {
            ...state,
            ...{loading: {...state.loading, ...action.payload}}
        };
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/Global/reducer.js